export default "__VITE_ASSET__BCNq8oQI__"